import { authwsEnvironment } from '../authws-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { AuthHeaders } from '../../../models/auth-headers';
import { ignoreData } from '../../../utils/ignore-data';
import { accountProductRelationshipSchema } from '../schemas/account-product-relationship.schema';
import { parseRequestSchema } from '../../../utils/parse-request-schema';
import { dateToISOStringPreprocessor } from '../../../utils/date-to-iso-string-preprocessor';
import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

const requestSchema = accountProductRelationshipSchema
  .omit({
    manageOwnAPIKeys: true,
    phone: true,
  })
  .partial()
  .required({
    accountState: true,
  })
  .extend({
    product: z.string().min(1),
  });

/**
 * Assigns a list of Trimble Maps applications to an account
 * @param accountId Id of Account to assign products
 * @param products Array of Trimble Maps applications to assign
 */
export function postProductsMultipleAccounts(
  this: unknown,
  accountId: number,
  products: z.infer<typeof requestSchema>[]
) {
  return fromFetch(
    new Request(
      `${
        authwsEnvironment.resolve(this).productsMultipleAccountsUrl
      }/${encodeURIComponent(accountId)}`,
      {
        method: 'POST',
        headers: {
          ...requiredHeaders,
          ...new AuthHeaders(),
        },
        body: parseRequestSchema(
          z.array(
            requestSchema.extend({
              expirationDate: dateToISOStringPreprocessor()
                .nullable()
                .optional(),
            })
          ),
          products
        ),
      }
    )
  ).pipe(ignoreData());
}
